module.exports = __webpack_public_path__ + "personajuridica.png?a5216f227934ef2b0473f725dc5287ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/personajuridica.png
// module id = 658
// module chunks = 0 2 7 8 9 10 21